import { createSelector, createStructuredSelector } from 'reselect'
import { createGetState, createReduxTargetSelector } from '../../commons/Redux/selector'
import { createTargetSelector } from '../../commons/Redux/utils'

export const getTestFetchTarget = createTargetSelector('test-fech')

export const mapStateToProps = () => {

    const storeTargetTestFetch = createReduxTargetSelector(getTestFetchTarget)

    const mapLocalStateToProps = createStructuredSelector({
        storeTargetTestFetch
    })

    return createSelector(
        createGetState(),
        (_, props) => props,
        mapLocalStateToProps
    )
}
